import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeRoutingModule } from './home-routing.module';
import { HomeComponent } from './home.component';
import { SharedModule } from '../../shared/shared.module';
import { HomeTilesComponent } from './components/home-tiles/home-tiles.component';
import { HomeCarouselComponent } from './components/home-carousel/home-carousel.component';
import { CarouselItemDirective } from '@app/main/home/directives/carousel-item.directive';
import { CarouselItemElementDirective } from '@app/main/home/directives/carousel-item-element.directive';

@NgModule({
    declarations: [
        HomeComponent,
        HomeTilesComponent,
        HomeCarouselComponent,
        CarouselItemDirective,
        CarouselItemElementDirective
    ],
    imports: [CommonModule, SharedModule, HomeRoutingModule]
})
export class HomeModule {}
